export const usPhoneNumberRegex = /\(?\d{3}\)?-? *\d{3}-? *-?\d{4}/;

export const ukPhoneNumberRegex = /^[\d()-\s+]{6,}$/;

export const zaPhoneNumberRegex = /^[\d()-\s+]{6,}$/;

export const jpPhoneNumberRegex = /^(?:\+81|0)[ -]?\d{1,4}[ -]?\d{1,4}[ -]?\d{4}$/;
